import type { IPagesMenuParams } from 'pinia-store/pages'
import dayjs from 'dayjs'

function handleQueryUrl(url, queries) {
  try {
    if (!url)
      return

    url = new URL(url)

    if (queries) {
      Object.entries(queries).forEach(([k, v]) => {
        url.searchParams.set(k, v)
      })
    }
    return url.href
  }
  catch (error) {
    console.warn('[handleQueryUrl', error)
  }
}

export function initMenu(menu: IPagesMenuParams[], scope = 'is_navbar'): IPagesMenuParams[] {
  const tmp = menu
  let arr: IPagesMenuParams[] = []
  const data: IPagesMenuParams[] = []

  if (tmp && tmp.length && scope) {
    arr = tmp.filter(
      (el: IPagesMenuParams) =>
        el[scope]
        && (scope === 'is_navbar'
          || (scope === 'is_footer'
            && ['privacy-policy', 'term-n-condition', 'enviromental-policy'].findIndex(
              (str: string) => str === el.slug,
            ) === -1)),
    )
  }

  if (arr && arr.length) {
    for (let i = 0; i < arr.length; i++) {
      if (
        arr[i]
        && arr[i].slug
        && (data.length === 0 || (data.length && data.findIndex((el: any) => el?.slug === arr[i].slug) === -1))
      )
        data.push(arr[i])
    }
  }

  return data
}

export function initMenuTemplates(menu) {
  const tmp = menu
  let arr: any = []
  const data: any = []
  if (tmp && tmp.length)
    arr = tmp.filter((el: any) => (el.is_footer || el.is_navbar))

  if (arr && arr.length) {
    for (let i = 0; i < arr.length; i++) {
      if (
        arr[i]
        && arr[i].slug
        && (data.length === 0 || (data.length && data.findIndex((el: any) => el?.slug === arr[i].slug) === -1))
      )
        data.push(arr[i])
    }
  }

  return data
}

export function replacePath(str) {
  return str.replace('https://static.pbahotels.com/', 'https://images.archipelagohotels.com/pbahotels/')
}

export function toQueryUrl(val: any, queries: any) {
  try {
    const url
      = 'https://images.archipelagohotels.com/pbahotels/Assets/images/Hotel/exterior/ddd423f5d935c446a9c21cc294747936033ef0c3.png'
    if (!val)
      return url
    return handleQueryUrl(replacePath(val), queries)
  }
  catch (error) {
    console.warn('[toQueryUrl]', error)
  }
}

export function isNode(o) {
  return typeof Node === 'object'
    ? o instanceof Node
    : o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string'
}

// Returns true if it is a DOM element
export function isElement(o) {
  return typeof HTMLElement === 'object'
    ? o instanceof HTMLElement // DOM2
    : o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string'
}

export function isValidUrl(urlString) {
  if (!urlString)
    return ''

  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' // validate protocol
      + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // validate domain name
      + '((\\d{1,3}\\.){3}\\d{1,3}))' // validate OR ip (v4) address
      + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // validate port and path
      + '(\\?[;&a-z\\d%_.~+=-]*)?' // validate query string
      + '(\\#[-a-z\\d_]*)?$',
    'i',
  ) // validate fragment locator
  return !!urlPattern.test(urlString)
}

export function checkUrlDimension(val) {
  if (!val || !isValidUrl(val))
    return ''

  const str = new URLSearchParams(val)
  let bool = false
  if (str.get('d'))
    bool = true

  return bool
}

// Lazy Image Source : height 64 - width follow ratio or 64
export function getLazySrc(val, isObj: boolean = false) {
  if (!val || !isValidUrl(val))
    return ''

  const str = new URLSearchParams(val)
  const { origin, pathname } = new URL(val)
  let x = 1000
  let y = 64
  let url = `${origin}`
  if (pathname)
    url += pathname

  const size = str.get('d')
  const location = str.get('location')
  if (size && size.indexOf('x') > 0) {
    const split = size.split('x')
    x = Number(split[0])
    y = Number(split[1])
  }

  const ratio = x & y ? x / y : 1
  url += `?d=${Math.floor(64 * ratio)}x64`
  if (location)
    url += `&location${location}`

  if (isObj) {
    return {
      width: x,
      height: y,
      url,
    }
  }
  return url
}

export function linkBookingNow(event, { source, hotelSimplebooking, splitDate, adults, childs }) {
  try {
    event.preventDefault()
    if (hotelSimplebooking && source === 'booking_form') {
      const bookUrl = new URL(hotelSimplebooking)
      const populateAdults = Array(adults).fill('A').join(',') // fill 'A', came from simpleBooking
      const populateChilds = childs > 0 ? `,${Array(childs).fill('2').join(',')}` : '' // default age of child set to 2 age.
      bookUrl.searchParams.set('in', dayjs(splitDate[0].toString()).format('YYYY-MM-DD'))
      bookUrl.searchParams.set('out', dayjs(splitDate[1].toString()).format('YYYY-MM-DD'))
      bookUrl.searchParams.set('guests', `${encodeURI(populateAdults)}${encodeURI(populateChilds)}`)
      // need to add again after query hash '#q' from simpleBooking
      window.open(
        `${bookUrl}#q&guests=${encodeURI(populateAdults)}${encodeURI(populateChilds)}&in=${dayjs(splitDate[0].toString()).format('YYYY-MM-DD')}&out=${dayjs(splitDate[1].toString()).format('YYYY-MM-DD')}`,
        '_blank',
      )
    }
    else if (hotelSimplebooking) {
      window.open(hotelSimplebooking, '_blank')
    }
  }
  catch (error) {}
}

export function transformURL(url: string): string {
  const regex = /^www\./i
  if (regex.test(url))
    return url.replace(regex, 'https://')

  return url
}

export function removeQueryParams(url: string, params: string[]): string {
  if (!url || !params || !params.length)
    return url

  const parsedUrl = new URL(url)
  params.forEach((param) => {
    parsedUrl.searchParams.delete(param)
  })

  return parsedUrl.toString()
}

export function getQueryParams(url: string): Record<string, string> {
  if (!url)
    return {}

  const parsedUrl = new URL(url)
  const params: Record<string, string> = {}
  parsedUrl.searchParams.forEach((value, key) => {
    params[key] = value
  })

  return params
}
